import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoSalaryCoin = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>SalaryCoin</title>
    <circle
      cx={15.999}
      cy={16.994}
      r={13}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.178 8.456v2.65m0 11.571v2.815M19.27 12.65c-2.314-2.314-6.319-1.104-6.17 1.543.198 3.538 5.21 1.665 6.17 4.628.572 1.764-.676 3.857-3.856 3.857-2.314 0-3.343-1.543-3.857-2.314"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoSalaryCoin;
